import { BsPersonCheck } from 'react-icons/bs';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const investors = {
  id: 'investors',
  title: '',
  type: 'group',
  children: [
    {
      id: 'investors-management',
      title: 'Investors',
      type: 'item',
      url: '/investors-list',
      icon: BsPersonCheck,
      allowedRoles: ['admin', 'superAdmin', 'financeManager', 'complianceOfficer', 'marketingSpecialist'],
      breadcrumbs: false
    }
  ]
};

export default investors;
